"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateService = void 0;
var end2end_1 = require("@hudled/end2end");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var omitBy_1 = __importDefault(require("lodash/omitBy"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var backend_1 = require("utils/backend");
var firestore_1 = require("utils/firebase/firestore");
var storage_1 = require("utils/firebase/storage");
var hooks_1 = require("utils/hooks");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var combineErrors = function () {
    var errorStrings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        errorStrings[_i] = arguments[_i];
    }
    return errorStrings.filter(end2end_1.notFalsy).join(' ');
};
var useCreateService = function (onClose, defaultUncuratedService) {
    var _a = __read((0, hooks_1.useSubmitter)('services'), 1), submitNewService = _a[0];
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var store = (0, react_redux_1.useStore)();
    var _b = __read((0, react_1.useState)(null), 2), matchingServices = _b[0], setMatchingServices = _b[1];
    var _c = __read(react_1.default.useState(defaultUncuratedService), 2), uncuratedService = _c[0], setUncuratedService = _c[1];
    var setUncSrvAndReset = function (uS) {
        setMatchingServices(null);
        setUncuratedService(uS);
    };
    var createService = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var reducedName, reducedNiceName, err, state, services, nameMatchingServices, niceNameMatchingServices, uncuratedServices, uncuratedSrvsNameMatch, uncuratedSrvsNiceNMatch, serviceId, newServiceRef, newService, logoFields;
        var _b;
        var logoFileArr = _a.logoFileArr, force = _a.force, serviceVals = __rest(_a, ["logoFileArr", "force"]);
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setMatchingServices(null);
                    reducedName = (0, end2end_1.reduceName)(serviceVals.name);
                    reducedNiceName = (0, end2end_1.reduceName)(serviceVals.niceName);
                    if (!(!force && (!uncuratedService || ![reducedName, reducedNiceName].includes(uncuratedService.reducedName)))) return [3 /*break*/, 3];
                    err = {};
                    state = store.getState();
                    services = (0, ordered_1.selectServices)(state);
                    nameMatchingServices = (_b = services === null || services === void 0 ? void 0 : services.filter(function (s) { return ((0, end2end_1.reduceName)(s.name) === reducedName || (0, end2end_1.reduceName)(s.niceName) === reducedName); })) !== null && _b !== void 0 ? _b : [];
                    niceNameMatchingServices = serviceVals.niceName && services
                        ? services.filter(function (s) { return (0, end2end_1.reduceName)(s.name) === reducedNiceName || (s.niceName && (0, end2end_1.reduceName)(s.niceName) === reducedNiceName); })
                        : undefined;
                    if (nameMatchingServices.length || (niceNameMatchingServices === null || niceNameMatchingServices === void 0 ? void 0 : niceNameMatchingServices.length)) {
                        err.name = nameMatchingServices.length
                            ? "Matching: ".concat(nameMatchingServices.map(function (s) { return s.niceName || s.name; }).join(', '), ".")
                            : undefined;
                        err.niceName = (niceNameMatchingServices === null || niceNameMatchingServices === void 0 ? void 0 : niceNameMatchingServices.length)
                            ? "Matching: ".concat(niceNameMatchingServices.map(function (s) { return s.niceName || s.name; }).join(', '), ".")
                            : undefined;
                    }
                    return [4 /*yield*/, (0, firestore_1.getData)('services_uncurated', ['reducedName', 'in', [reducedName, reducedNiceName].filter(end2end_1.notFalsy)])];
                case 1:
                    uncuratedServices = (_c.sent()).filter(function (uS) { return !uS.moved; });
                    if (uncuratedServices.length) {
                        uncuratedSrvsNameMatch = uncuratedServices.filter(function (uS) { return uS.reducedName === reducedName; });
                        uncuratedSrvsNiceNMatch = uncuratedServices.filter(function (uS) { return uS.reducedName === reducedNiceName; });
                        if (uncuratedSrvsNameMatch === null || uncuratedSrvsNameMatch === void 0 ? void 0 : uncuratedSrvsNameMatch.length) {
                            err.name = combineErrors(err.name, "Matching uncurated: ".concat(uncuratedSrvsNameMatch.map(function (uS) { return uS.name; }).join(', '), "."));
                        }
                        if (uncuratedSrvsNiceNMatch === null || uncuratedSrvsNiceNMatch === void 0 ? void 0 : uncuratedSrvsNiceNMatch.length) {
                            err.niceName = combineErrors(err.niceName, "Matching uncurated: ".concat(uncuratedSrvsNiceNMatch.map(function (uS) { return uS.name; }).join(', '), "."));
                        }
                    }
                    if (!!(0, isEmpty_1.default)(err)) return [3 /*break*/, 3];
                    setMatchingServices((0, omitBy_1.default)({ uncuratedServices: uncuratedServices, nameMatchingServices: nameMatchingServices, niceNameMatchingServices: niceNameMatchingServices }, isEmpty_1.default));
                    return [4 /*yield*/, (0, end2end_1.delay)(500)];
                case 2:
                    _c.sent();
                    return [2 /*return*/, (0, omitBy_1.default)(err, isEmpty_1.default)];
                case 3:
                    if (!uncuratedService) return [3 /*break*/, 5];
                    return [4 /*yield*/, (0, backend_1.callBackendFn)('service-moveSingleUncurated', { uncuratedServiceId: uncuratedService.id, newData: serviceVals })];
                case 4:
                    _c.sent();
                    serviceId = uncuratedService.id;
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, submitNewService(serviceVals)];
                case 6:
                    newServiceRef = _c.sent();
                    serviceId = newServiceRef.id;
                    _c.label = 7;
                case 7:
                    if (!(logoFileArr === null || logoFileArr === void 0 ? void 0 : logoFileArr[0])) return [3 /*break*/, 10];
                    newService = __assign({ id: serviceId }, serviceVals);
                    return [4 /*yield*/, (0, storage_1.uploadServiceLogo)(newService, logoFileArr[0], profile.id)];
                case 8:
                    logoFields = _c.sent();
                    return [4 /*yield*/, (0, firestore_1.updateDoc)('services', serviceId, logoFields)];
                case 9:
                    _c.sent();
                    _c.label = 10;
                case 10:
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                    return [2 /*return*/, undefined];
            }
        });
    }); };
    return [createService, matchingServices, function () { return setMatchingServices(null); }, setUncSrvAndReset, uncuratedService];
};
exports.useCreateService = useCreateService;
